module.exports = __webpack_public_path__ + "img/about-canvas.a8f4951e.jpg";